/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import clsx from 'clsx'

const ImageResizeComponent = (props) => {
  const attrs = props?.node?.attrs
  const handler = (mouseDownEvent) => {
    const parent = mouseDownEvent.target.closest('.custom-image')
    const image = parent?.querySelector('img.postimage') ?? null
    if (image === null) return
    const startSize = { x: image.clientWidth, y: image.clientHeight }
    const startPosition = { x: mouseDownEvent.pageX, y: mouseDownEvent.pageY }

    function onMouseMove(mouseMoveEvent) {
      props.updateAttributes({
        width: startSize.x - startPosition.x + mouseMoveEvent.pageX,
        height: startSize.y - startPosition.y + mouseMoveEvent.pageY,
      })
    }
    function onMouseUp() {
      document.body.removeEventListener('mousemove', onMouseMove)
    }

    document.body.addEventListener('mousemove', onMouseMove)
    document.body.addEventListener('mouseup', onMouseUp, { once: true })
  }

  const map = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
  }

  const containerStyle = {
    justifyContent: map[props.node.attrs?.textAlign || 'left'],
  }

  const imageStyle = {
    borderRadius: attrs?.borderRadius,
  }

  return (
    <NodeViewWrapper
      className={clsx('custom-image', { selected: props?.selected })}
      style={containerStyle}
    >
      <div className="custom-image-wrapper">
        <img
          width={attrs?.width}
          src={attrs?.src}
          alt={attrs?.alt}
          style={imageStyle}
          className="postimage"
          draggable="true"
          data-drag-handle=""
        />
        <div className="resize-trigger" onMouseDown={handler}>
          {props.extension.options.resizeIcon}
        </div>
      </div>
    </NodeViewWrapper>
  )
}

export default ImageResizeComponent
